// package
import pkg from '../../package.json'

interface Project {
  name: string
  package: {
    name: string
    version: string
    npmUrl: string
  }
  urls: {
    main: string
    docs: string
    support: string
    buy: string
  }
}

const project: Project = {
  name: 'Metaeditor',
  package: {
    name: pkg.name,
    version: pkg.version,
    npmUrl: `https://www.npmjs.com/package/${pkg.name}`,
  },
  urls: {
    main: 'http://metaeditor.io/',
    docs: 'https://metaeditor.io/docs',
    support: 'https://unrealos.com/p/contacts/',
    buy: 'https://unrealos.com/apps/metaeditor/'
  }
}

export default project